import { render, staticRenderFns } from "./OccurrenceTypeEdit.vue?vue&type=template&id=31c5b6e8"
import script from "./OccurrenceTypeEdit.vue?vue&type=script&lang=js"
export * from "./OccurrenceTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports